import gql from 'graphql-tag';

export const COMPLETED_PAYMENT_INFO_FRAGMENT = gql`
  fragment CompletedPaymentInfo on CheckoutSession {
    completedPaymentInfo {
      transactionId
      transactionState
      receiptId
      softDescriptor
      postbackData
    }
  }
`;
